import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

/**
 * Pings the server every ~60s while the tab is visible so other members
 * can see who is currently in the Club.
 */
export function usePresenceHeartbeat(enabled: boolean) {
  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    const ping = async () => {
      if (cancelled || document.hidden) return;
      await supabase.rpc("community_touch_presence");
    };
    ping();
    const id = setInterval(ping, 60_000);
    const onVis = () => { if (!document.hidden) ping(); };
    document.addEventListener("visibilitychange", onVis);
    return () => {
      cancelled = true;
      clearInterval(id);
      document.removeEventListener("visibilitychange", onVis);
    };
  }, [enabled]);
}